import React, { Fragment } from 'react';

import numeral from 'numeral';
import moment from 'moment';

import {
  Box,
  makeStyles,
  TableCell,
  TableRow,
  Tooltip,
  colors,
  Avatar,
  IconButton,
  Icon,
  Grid,
  Link,
  Typography
} from '@material-ui/core';

import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import BuildIcon from '@material-ui/icons/Build';
import EditRoundedIcon from '@material-ui/icons/EditRounded';

const useStyles = makeStyles((theme) => ({
  root: {
  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200]
  }
}));

const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const Record = ({ icon, item, vision, resultMode, openEdition, openDeletion, openTreatment, appointments }) => {

  const classes = useStyles();

  const formatDecimal = (value) => {
    return numeral(value).format('0.00').replace('.', ',');
  }

  const formatNumber = (value, mask) => {
    return numeral(value).format(mask);
  }

  const formatDate = (value) => {
    if (value) {
      return moment(value).format('DD/MM/YYYY')
    } else {
      return ""
    }
  }

  const formatDatetime = (value) => {
    if (value) {
      return moment(value).format('DD/MM/YYYY HH:mm')
    } else {
      return ""
    }
  }

  const truncateValue = (value, size) => {
    if (value.length > size) {
      return value.substring(size - 3, 0) + '...';
    } else {
      if (value == '') {
        return 'Não Definido'
      } else {
        return value;
      }
    }
  }

  const getName = (value) => {
    return appointments.typesTechnician.map((element, index) => {
      if (element.id == value.tecnico.PRESTADORA) {
        return element.nome;
      }
    });
  }

  const getFieldValue = (column) => {
    try {
      var value = eval(column.field);
      return ((value) ? value : "");
    } catch (error) {
      return "Não Informado";
    }
  }

  const getStyleActionsAjustment = (resultMode) => {
    var distance = (resultMode.update + resultMode.delete + resultMode.config) * 160;
    return { maxWidth: distance, minWidth: distance };
  }

  return (
    <Fragment>

      <TableRow hover key={item.id} className={classes.root}>

        {resultMode.columns.map((col, index) => (
          (index == 0) ? (

            <TableCell>
              <Box
                noWrap={(col.wrap)}
                alignItems="center"
                display="flex"
                component={Link}
                onClick={() => { (resultMode.update == LEVEL_ACCESS_ENABLED) ? openEdition(item) : {} }}
              >
                <Avatar
                  className={classes.avatar}
                >
                  {<Icon component={icon} style={{ color: colors.cyan[500] }} ></Icon>}
                </Avatar>
                {getFieldValue(col)}
              </Box>
            </TableCell>

          ) : (
            <TableCell>
              <Typography variant="body" noWrap={(col.wrap)}  >
                {getFieldValue(col)}
              </Typography>
            </TableCell>)
        ))}

        <TableCell align="right" >
          <Grid container style={getStyleActionsAjustment(resultMode)} >
            {(resultMode.config != LEVEL_ACCESS_HIDE) ? (
              <Grid item
                md={4}
                xl={4}
              >
                <Tooltip title="Tratar">
                  <IconButton
                    color="secondary"
                    disabled={localStorage.getItem('profile') != 'ENG'}
                    children={<BuildIcon />}
                    size="medium"
                    onClick={() => { openTreatment(item) }}></IconButton>
                </Tooltip>
              </Grid>
            ) : ('')}

            {(resultMode.update != LEVEL_ACCESS_HIDE) ? (
              <Grid item
                md={4}
                xl={4}
              >
                <Tooltip title="visualizar">
                  <IconButton
                    color="secondary"
                    disabled={localStorage.getItem('profile') != 'ENG'}
                    children={<EditRoundedIcon />}
                    size="medium"
                    onClick={() => { openEdition(item) }}>
                  </IconButton>
                </Tooltip>
              </Grid>
            ) : ('')}

            {(resultMode.delete != LEVEL_ACCESS_HIDE) ? (
              <Grid item
                md={4}
                xl={4}
              >
                <Tooltip title={"Excluir"}>
                  <IconButton
                    color="secondary"
                    disabled={localStorage.getItem('profile') != 'ENG'}
                    children={<DeleteRoundedIcon />}
                    size="medium"
                    onClick={() => { openDeletion(item) }}></IconButton>
                </Tooltip>
              </Grid>
            ) : ('')}

          </Grid>
        </TableCell>

      </TableRow>

    </Fragment >
  );
}

export default Record;